export default __webpack_public_path__ + "static/media/Ballroll_00087.1f9b4716.png";